import { render, staticRenderFns } from "./OnlineMagazine.vue?vue&type=template&id=923913fc&"
import script from "./OnlineMagazine.vue?vue&type=script&lang=js&"
export * from "./OnlineMagazine.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports